import { gql } from '@apollo/client';

export const closeSessionGql = gql`
  mutation closeSession($sessionId: String!) {
    closeSession(sessionId: $sessionId)
  }
`;
